import { render } from "./MarkStudentPeriodAttendanceModal.vue?vue&type=template&id=23f26b3e&scoped=true"
import script from "./MarkStudentPeriodAttendanceModal.vue?vue&type=script&lang=js"
export * from "./MarkStudentPeriodAttendanceModal.vue?vue&type=script&lang=js"

import "./MarkStudentPeriodAttendanceModal.vue?vue&type=style&index=0&id=23f26b3e&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f26b3e"]])

export default __exports__